import api from "../../../services/api";

export const getStockItems = async () => {
  const response = await api.get("/flasks");
  return Array.isArray(response.data) ? response.data : [];
};

export const createStockItem = async (payload) => {
  const response = await api.post("/flasks", payload);
  return response.data;
};

export const updateStockItem = async (id, payload) => {
  if (!id) {
    throw new Error("ID do item não informado para atualização.");
  }

  const response = await api.put(`/flasks/${id}`, payload);
  return response.data;
};

export const updateStockItemStatus = async (id, action) => {
  if (!id) {
    throw new Error("ID do item não informado para atualização de status.");
  }

  if (!action) {
    throw new Error("A ação de status não foi informada.");
  }

  const response = await api.put(`/flasks/${id}/status`, { action });
  return response.data;
};

export const deleteStockItem = async (id) => {
  if (!id) {
    throw new Error("ID do item não informado para exclusão.");
  }

  const response = await api.delete(`/flasks/${id}`);
  return response.data;
};